// extracted by mini-css-extract-plugin
module.exports = {"container":"addEditFeaturedOffer_container__4HO4j","content":"addEditFeaturedOffer_content__1TLAZ"};